<template>
  <div class="P_user">
    <div class="P_user_content">
      <div class="P_user_header">
        <div class="P_portrait">
          <img v-lazy="user.img?user.img:hrefurl+'/public/icon/avatars.png'" alt="" />
          <UserHeaderUpload class="P_portrait_uploadtop"/>
        </div>
        <div class="information">
          <h3>
            {{user.name?user.name:user.nickname}}
            <span>{{user.duties?user.duties:""}}</span>
            <div v-if="this.user.authent*1==1" class="reveal">
              <img class="attestation" v-lazy="hrefurl+'/public/icon/attestation.jpg'" alt=""/>
              <div>
                <span></span>
                您已通过cippe展商认证
              </div>
            </div>
          </h3>
          <p>
            <span v-if="user.corpname">
              <img v-lazy="hrefurl+'/public/icon/pc_dizhi.png'" alt="" />
              {{user.corpname}}
              </span>
            <span >
              <img v-lazy="hrefurl+'/public/icon/pc_dianhua.png'" alt="" />
              {{user.mobile?user.mobile:user.phone}}
              </span>
            <span v-if="user.email">
              <img v-lazy="hrefurl+'/public/icon/pc_youxiang.png'" alt="" />
              {{user.email?user.email:"暂无"}}
              </span>
          </p>
        </div>
        <span class="editor" @click="open"><img v-lazy="hrefurl+'/public/icon/pc_bainji.png'" alt="" /></span>
      </div>
      <div class="P_user_main">
        <div class="P_user_nav">
          <div class="P_user_title">
            <h2>
              用户中心
              <div></div>
            </h2>
          </div>
          <ul class="P_user_collection">
            <li v-if="this.user.authent*1==1" class="exhLogin" @click="reqExhLoginHref" @mouseover="gody">
              <img v-lazy="hrefurl+'/public/icon/zhanshangdenglu.png'" alt=""/>
              展商登录系统
            </li>
            <li :class="msg.url==item.url?'active':''" v-for="(item,i) in collect" :key="'collect'+i" @click="userjump(item)">
              <img v-lazy="item.img_url" alt="" />
              {{item.title}}
            </li>
          </ul>
          <div class="P_user_title">
            <h2>
              展会相关
              <div></div>
            </h2>
          </div>
          <ul class="related_list">
            <!-- <li class="active"> -->
            <li @click="webHerf('https://www.cippe.com.cn/cn/aboutus/introduce')">
              <img v-lazy="hrefurl+'/public/icon/zhanhuigaikuang.png'" alt="" />
              展会概况
            </li>
            <!-- <li @click="webHerf('https://330003.youtucc.com/s/MzMwMDAz')"> -->
            <li>
              <img v-lazy="hrefurl+'/public/icon/zhanqianyulan.png'" alt="" />
              展前预览
            </li>
            <li @click="webHerf('https://www.cippe.com.cn/cn/visitors/guide')">
              <img v-lazy="hrefurl+'/public/icon/canguanzhinan.png'" alt="" />
              参观指南
            </li>
            <li @click="webHerf('https://www.cippe.com.cn/cn/businesstravel/hotel')">
              <img v-lazy="hrefurl+'/public/icon/jiudianyuding.png'" alt="" />
              酒店预订
            </li>
            <li @click="webHerf('http://www.cippe.com.cn/cn/businesstravel/traffic')">
              <img v-lazy="hrefurl+'/public/icon/jiaotongditu.png'" alt="" />
              交通地图
            </li>
            <li @click="webHerf('https://www.cippe.com.cn/cn/exhibitors/build/')">
              <img v-lazy="hrefurl+'/public/icon/dajian.png'" alt="" />
              指定搭建
            </li>
            <li @click="webHerf('https://www.cippe.com.cn/cn/exhibitors/transport')">
              <img v-lazy="hrefurl+'/public/icon/yunshu.png'" alt="" />
              运输服务
            </li>
            <li>
              <!-- <img src="https://picsum.photos/id/362/40/40" alt="" />
              运输服务 -->
            </li>
          </ul>
          <div class="P_user_title">
            <h2>
              咨询热线
              <div></div>
            </h2>
          </div>
          <ul class="hotline_list">
            <li>
              <img v-lazy="hrefurl+'/public/icon/canzhan.png'" alt="" />
              参展热线：010-56176968
            </li>
            <li>
              <img v-lazy="hrefurl+'/public/icon/cangaun.png'" alt="" />
              参观热线：010-56176941
            </li>
            <li>
              <img v-lazy="hrefurl+'/public/icon/rexian.png'" alt="" />
              技术热线：010-50917095
            </li>
            <li>
              <img v-lazy="hrefurl+'/public/icon/rexian.png'" alt="" />
              媒体合作：010-50917091
            </li>
          </ul>
        </div>
        <!-- 右侧切换 -->
        <div class="P_user_nav_right">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '' }">我的</el-breadcrumb-item>
            <el-breadcrumb-item>{{msg.title}}</el-breadcrumb-item>
          </el-breadcrumb>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {reqSendCode, reqMyinfoEdit, reqMyJumpCippe} from "../../../api"
import UserHeaderUpload from "./userHeadUpload"
export default {
  components:{
    UserHeaderUpload
  },
  data(){
    var checkName = (rule, value, callback) => {//M昵称
      if (!value.trim()) {
        return callback(new Error('昵称不能为空或空格'));
      }else{
        callback();
      }
    };
    var checkCorpname = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error('请填写单位名称'));
      }else{
        callback();
      }
    };
    var checkDuties = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error('请填写您的职位'));
      }else{
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        this.disabled=true
        callback(new Error("请输入手机号"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          this.disabled=false
          callback();
        }
      }
    };
    var checkCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (this.flagCode) {
          callback(new Error("请输入正确的验证码"));
        } else {
          callback();
        }
      }
    };
    return{
      collect:[
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yixiangdingdan.png",
          url:"/user/intentionOrder",
          title_cn:"意向订单",
          title_en:"意向订单",
          title:"意向订单",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanshangshoucang.png",
          url:"/user/merchantsCollection",
          title_cn:"展商收藏",
          title_en:"展商收藏",
          title:"展商收藏",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanpinshoucang.png",
          url:"/user/goodsCollection",
          title_cn:"展品收藏",
          title_en:"展品收藏",
          title:"展品收藏",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yiyuezhanshang.png",
          url:"/user/aboutGoods",
          title_cn:"已约展商",
          title_en:"已约展商",
          title:"已约展商",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/guanzhongyaoqing.png",
          url:"/user/aboutAudience",
          title_cn:"观众邀约",
          title_en:"观众邀约",
          title:"观众邀约",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/caigou.png",
          url:"/user/purchaseManagement",
          title_cn:"采购管理",
          title_en:"采购管理",
          title:"采购管理",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/gongying.png",
          url:"/user/supplyManagement",
          title_cn:"供应管理",
          title_en:"供应管理",
          title:"供应管理",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/pinglun1.png",
          url:"/user/comments",
          title_cn:"我的评论",
          title_en:"我的评论",
          title:"我的评论",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/xunpan.png",
          url:"/user/consulting",
          title_cn:"询盘",
          title_en:"询盘",
          title:"询盘",
        }
      ],
      collectActive:'',
      title:'',
      rules: {
        name: [
          { required: true,validator: checkName, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        corpname: [
          { required: true,validator: checkCorpname, trigger: 'blur' }
        ],
        duties: [
          { required: true,validator: checkDuties, trigger: 'blur' }
        ],
        mobile: [
          { required: true,validator: checkPhone, trigger: 'blur' }
        ],
        mobileVerify: [
          { required: true,validator: checkCode, trigger: 'blur' }
        ]
      },
      ruleForm: {
        name: '',
        email: '',
        corpname: '',
        duties:'',
        mobile:'',
        mobileVerify:''
      },
      disabled:true,//发送验证码
      countdown:"发送验证码",//倒计时
      flagCode:false,
      exhLoginUrl:'',//展商登录地址
      godyflag:false,//展商登录系统文字提示
    }
  },
  mounted(){
    this.collectActive = this.$route.path
    let a = this.collect.find(item=>item.url==this.collectActive)
    this.$store.dispatch('userTitle',a)
    if (!this.isLogin) {
      this.$router.push('/home')
    }
    if (this.user.authent*1!=1) {
      this.collect.splice(4,1)
    }
  },
  methods:{
    async reqCode(){//获取验证码
      const response = await reqSendCode(this.ruleForm.mobile)
      if (response.code==1) {
        this.success(this,"验证码发送成功！")
        this.countdown = 90
        this.disabled = true
        this.time()
      }else if(response.code==0){
        this.err(this,"验证码发送失败，请稍后再试...")
        this.countdown = "发送验证码"
      }
    },
    time(){//倒计时
      this.timer = setInterval(()=>{
        this.countdown--
        if (this.countdown<=0) {
          clearInterval(this.timer)
          this.countdown = "重新发送验证码"
          this.disabled = false
        }
      },1000)
    },
    submitForm(formName) {//提交表单
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
          const response = await reqMyinfoEdit(this.ruleForm)
          if (response.code == 4) {
            this.$store.dispatch("userInformation",response.resilt)
            this.success(this,'修改成功')
            clearInterval(this.timer)
            this.$store.dispatch('information',false)
          }else if(response.code == 3){
            this.err(this,'修改失败，请稍后重试...')
          }else if(response.code == 2){
            this.err(this,'修改失败，请稍后重试...')
          }else if(response.code == 1){
            this.err(this,'验证码不正确,请重新输入...')
            this.flagCode=true
            // this.$refs.code.validateField(()=>false)
          }else if(response.code == 0){
            this.err(this,'非法访问！')
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {//清空表单
      // this.$refs[formName].resetFields();
      // console.log("清除");
      clearInterval(this.timer)
      this.$store.dispatch('information',false)
    },


    open(){//打开修改弹窗
      //根据获取来的个人信息 初始显示表单数据
      // console.log(this.user);
      // let {name, email, corpname, duties, mobile} = this.user
      // this.ruleForm={
      //   name,
      //   email,
      //   corpname,
      //   duties,
      //   mobile,
      // }
      // if (mobile) {
      //   this.disabled = false
      // }
      //判断是否有手机号 有责将disabled修改发送验证码状态改为false
      this.$store.dispatch('information',true)
      this.$store.dispatch('informationState',true)
    },
    userjump(item){
      this.$router.push(item.url)
      // this.collectActive = url
      // this.title = title
      this.$store.dispatch('userTitle',item)
    },
    async reqExhLoginHref(){
      const response = await reqMyJumpCippe()
      if (response.code*1==2) {
        this.webHerf('https://'+response.webaddress)
      } 
    },
    gody(){
      this.godyflag = true
    }

  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
      isLogin:state=>state.user.isLogin,
      msg:state=>state.user.msg,
      information:state=>state.user.information
    })
  },
}
</script>

<style scoped>
  .P_user{
    /* background-color: rgb(243, 217, 226); */
    padding-top: 130px;
    background: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/user/userpage_bg.jpg") no-repeat;
    background-color: white;
    background-size: 100% ;
  }
  .P_user_content{
    max-width: 1200px;
    margin: 0 auto;
  }
  .P_user_header{
    position: relative;
    height: 190px;
    background-color: #008baf;
    background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/user/user_bg.jpg");
    background-size: 100% 100%;
  }
  .P_user_header::after{
    display: block;
    content: "";
    clear: both;
  }
  .P_portrait{
    position: relative;
    float: left;
    width: 114px;
    height: 114PX;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #a8aaa7;
    margin:40px 88px 20px 88px;
  }
  .P_portrait_uploadtop{
    position: absolute;
    left: 0;
    top: 0;
    width: 108px;
    height: 108px;
    /* background-color: pink; */
  }
  .P_portrait_uploadtop>>>.el-upload{
    width: 100%;
    height: 100%;
  }
  .information{
    float: left;
    padding: 55px 0 0; 
    color: white;
  }
  .information>h3{
    font-size: 28px;
    /* font-weight: 600; */
  }
  .information>h3>span{
    font-size: 22px;
    /* font-weight: 300; */
    margin-left: 10px;
    vertical-align: bottom;
  }
  .reveal{
    position: relative;
    display: inline-block;
  }
  .attestation{
    height: 20px;
    width: 80px;
    vertical-align: bottom;
    margin-left: 16px;
  }
  .reveal>div{
    display: none;
    position: absolute;
    left: calc(50% - 61px);
    bottom: -70px;
    padding: 10px;
    background-color: white;
    box-shadow: 0 0 2px #000;
    font-size: 12px;
    width: 140px;
    border-radius: 4px;
    color: #333;
  }
  .reveal>div>span{/*三角 */
    position: absolute;
    top: -20px;
    left: calc(50% - 10px);
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    border-left: 10px solid transparent;
  }
  .reveal:hover div{
    display: inline-block;
  }
  
  .information>p{
    font-size: 16px;
    margin-top: 20px;
  }
  .information>p>span{
    margin-right: 20px;
  }
  .information>p>span>img{
    width: 40px;
    margin-right: 8px;
  }
  /* 编辑 */
  .editor{
    position: absolute;
    right: 50px;
    top: 50px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
  }

  /* P_user_main start */
  .P_user_main{
    margin-top: 10px;
    display: flex;
    padding-bottom: 20px;
  }
  .P_user_nav{
    width: 300px;
    /* height: 500px; */
    /* background-color: #f1f1ef; */
    
  }
  .P_user_title{
    background-color: #008baf;
    overflow: hidden;
  }
  .P_user_title>h2{
    position: relative;
    font-size: 28px;
    color: white;
    border-left: 4px solid #fff;
    margin-left: 56px;
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 14px;
    line-height: 1;
  }
  .P_user_title>h2>div{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    /* background-color: white; */
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid white;
    border-bottom: 10px solid transparent;
    border-left: 10px solid transparent;
  }
  .P_user_collection{
    width: 100%;
    line-height: 70px;
    font-size: 16px;
    color: #585856;
    vertical-align: middle;
    user-select: none;
    background-color: #f1f1ef;
  }
  .P_user_collection>li{
    padding-left: 76px;
    cursor: pointer;
  }
  /* .exhLogin{ */
    /* color: #f08300; */
    /* background-color: rgba(0,139,175, .2); */
    /* font-weight: 600; */
    /* color: #008baf;
    background-color: #f08300;
    transition: all .5s;
    font-weight: 600;
    font-size: 18px;
  } */
  /* .P_user_collection .exhLogin:hover{
    background-color: #f08300;
    color: #008baf;
  } */
  
  /* 展会相关 start*/
  .related_list{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background-color: white;
  }
  .related_list>li{
    width: calc(50% - 2px);
    height: 145px;
    text-align: center;
    /* background-image: url("../../../assets/img/icon/cippe.png"); */
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f1f1ef;
    box-sizing: border-box;
    padding: 30px 35px 0 35px;
    margin-top: 4px;
    user-select: none;
    font-size: 14px;
    cursor: pointer;
    
  }
  .related_list>li:nth-child(1),
  .related_list>li:nth-child(2){
    margin-top: 0;
    /* border-top-right-radius: 0;
    border-top-left-radius: 0; */
  }
  .related_list>li:nth-child(2n+1){
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .related_list>li:nth-child(2n){
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .related_list>li>img{
    max-width: 100%;
    max-height: 60px;
    /* margin-bottom: 10px; */
  }
  /* 展会相关 start*/

  /* 咨询热线 start */
  .hotline_list{
    width: 100%;
    padding: 30px 0;
    font-size: 14px;
    background-color: #f1f1ef;
  }
  .hotline_list>li{
    width: 100%;
    /* line-height: 26px; */
    vertical-align: middle;
    padding: 12px 0;
    text-align: center;
  }
  .hotline_list>li>img{
    width: 40px;
    vertical-align: middle;
    /* margin-right: 6px; */
  }
  /* 咨询热线 end */



  .P_user_nav_right{
    /* background-color: slateblue; */
    width: calc(100% - 310px);
    margin-left: 10px;
    background-color: white;
  }
  .P_user_nav_right>>>.el-breadcrumb{
    font-size: 16px;
    padding: 20px 30px;
    /* border: 1px solid #aaa; */
    margin-bottom: 10px;
    background-color: white;
    color: #008baf;
  }
  .P_user_nav_right>>> .el-breadcrumb__inner{
    color: #008baf;
    cursor: pointer;
  }

  /* P_user_main end */

  .P_user_collection>.active,
  .P_user_collection>li:hover,
  .related_list>.active,
  .related_list>li:hover{
    color: #008baf;
    background-color: rgba(0,139,175, .2);
  }
  .P_user_collection>li>img{
    width: 40px;
    /* margin-right: 20px; */
    vertical-align: middle;
  }


  /* 修改个人资料 start */
  .P_portrait>>>.el-input__inner{
    color: #333;
  }
  .P_user_content>>>.el-dialog--center .el-dialog__body{
    padding-left: 100px;
    padding-right: 120px;
    text-align: center;
  }
  .P_user_content>>>.el-button{
    padding: 10px 26px;
  }
  .P_user_content>>>.el-button+.el-button{
    margin-left: 20px;
  }
  .button{
    width: 40%;
    height: 40px;
  }
  .phoneCode{
    width: 56%;
    margin-right: 4%;
  }

  /* 修改个人资料 end */

  @media (min-width: 768px) and (max-width: 1200px) {
    
    .P_user_nav{
      width: 200px;
    }
    .P_user_title>h2{
      margin-left: 20px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .P_user_collection>li{
      padding-left: 20px;
    }
    .related_list>li{
      padding:10px 0;
      height: auto;
    }
    .P_user_nav_right{
      width:calc(100% - 200px)
    }
  }
  @media (min-width: 768px) and (max-width: 992px) {
    .P_portrait{
      margin-left: 10px;
      margin-right: 10px;
    }
  }

</style>